import React, { useState, useEffect } from 'react';
import { Modal } from '../common/Modal';
import { Tag } from '../common/Tag';
import { useData } from '../../hooks/useData';
import { REPORT_TEMPLATES } from '../../utils/constants';

function ReportGenerateModal({ open, onClose, onGenerate }) {
  const { state } = useData();
  const [selectedTpl, setSelectedTpl] = useState('tpl_babe_feas');
  const [studyId, setStudyId] = useState('');
  const [feasibilityId, setFeasibilityId] = useState('');

  const study = state.studies.find((s) => s.id === studyId);
  const linkedFeas = state.feasibilities.filter((f) => f.studyId === studyId);

  useEffect(() => {
    if (linkedFeas.length > 0 && !feasibilityId) {
      setFeasibilityId(linkedFeas[0].id);
    }
  }, [studyId, linkedFeas, feasibilityId]);

  const submit = () => {
    onGenerate({ templateId: selectedTpl, studyId, feasibilityId });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Generate report"
      wide
      footer={
        <>
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" disabled={!studyId} onClick={submit}>
            <i className="ti ti-file-text" /> Generate draft
          </button>
        </>
      }
    >
      <div className="card-title">1. Select template</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 18 }}>
        {REPORT_TEMPLATES.map((t) => (
          <div
            key={t.id}
            onClick={() => setSelectedTpl(t.id)}
            style={{
              padding: '12px 14px',
              border: selectedTpl === t.id ? '2px solid var(--ink)' : '1px solid var(--line)',
              background: selectedTpl === t.id ? 'var(--surface-2)' : 'var(--surface)',
              borderRadius: 2,
              cursor: 'pointer'
            }}
          >
            <div className="flex between center mb-1">
              <div className="medium sm">{t.name}</div>
              {t.primary && <Tag variant="solid">Primary</Tag>}
            </div>
            <div className="xs muted">{t.desc}</div>
            <div className="mono xs muted mt-2">{t.code} · {t.sections.length} sections</div>
          </div>
        ))}
      </div>

      <div className="card-title">2. Select data source</div>
      <div className="field-row">
        <div className="field">
          <label className="field-label">Study <span className="req">*</span></label>
          <select value={studyId} onChange={(e) => setStudyId(e.target.value)}>
            <option value="">Select study...</option>
            {state.studies.map((s) => (
              <option key={s.id} value={s.id}>{s.code} · {s.molecule}</option>
            ))}
          </select>
        </div>
        <div className="field">
          <label className="field-label">Linked feasibility</label>
          <select
            value={feasibilityId}
            onChange={(e) => setFeasibilityId(e.target.value)}
            disabled={!studyId || linkedFeas.length === 0}
          >
            <option value="">None</option>
            {linkedFeas.map((f) => (
              <option key={f.id} value={f.id}>{f.code} · {f.status}</option>
            ))}
          </select>
        </div>
      </div>

      {study && (
        <div className="xs muted" style={{ background: 'var(--surface-2)', padding: 10, borderRadius: 2, marginTop: 10 }}>
          <div className="mb-1"><strong>Engine will pull from:</strong></div>
          • Study metadata for <span className="mono">{study.code}</span><br />
          • {state.knowledge.filter((k) => k.status === 'approved' && k.molecule?.toLowerCase() === study.molecule?.toLowerCase()).length} approved knowledge items for {study.molecule}<br />
          • {state.risks.filter((r) => r.studyId === study.id && r.status !== 'closed').length} open risks<br />
          • {feasibilityId ? `Feasibility ${state.feasibilities.find((f) => f.id === feasibilityId)?.code}` : 'No feasibility (sections will be marked incomplete)'}
        </div>
      )}
    </Modal>
  );
}

export default ReportGenerateModal;